export default "__VITE_ASSET__Dq1NUF9x__"